module.exports = __webpack_public_path__ + "static/media/coinbase_logo.74955d6b.svg";